var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoBlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/info"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44381 3.6853C8.08831 2.58649 10.0217 2 11.9995 2C13.3127 2 14.6131 2.25866 15.8264 2.7612C17.0396 3.26375 18.142 4.00035 19.0706 4.92893C19.9992 5.85752 20.7358 6.95991 21.2383 8.17317C21.7409 9.38642 21.9995 10.6868 21.9995 12C21.9995 13.9778 21.413 15.9112 20.3142 17.5557C19.2154 19.2002 17.6536 20.4819 15.8264 21.2388C13.9991 21.9957 11.9884 22.1937 10.0486 21.8079C8.1088 21.422 6.32697 20.4696 4.92845 19.0711C3.52992 17.6725 2.57752 15.8907 2.19166 13.9509C1.80581 12.0111 2.00384 10.0004 2.76072 8.17317C3.5176 6.34591 4.79932 4.78412 6.44381 3.6853ZM7.55495 18.6518C8.87055 19.5308 10.4173 20 11.9995 20C14.1212 20 16.1561 19.1571 17.6564 17.6569C19.1567 16.1566 19.9995 14.1217 19.9995 12C19.9995 10.4178 19.5303 8.87103 18.6513 7.55544C17.7722 6.23985 16.5228 5.21447 15.061 4.60896C13.5992 4.00346 11.9906 3.84504 10.4388 4.15372C8.88695 4.4624 7.46148 5.22433 6.34266 6.34315C5.22384 7.46197 4.46192 8.88743 4.15323 10.4393C3.84455 11.9911 4.00298 13.5997 4.60848 15.0615C5.21398 16.5233 6.23936 17.7727 7.55495 18.6518Z",
    fill: "#36382E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.49998C10.5 7.89781 10.658 8.27934 10.9393 8.56065C11.2206 8.84195 11.6022 8.99998 12 8.99998C12.3978 8.99998 12.7794 8.84195 13.0607 8.56065C13.342 8.27934 13.5 7.89781 13.5 7.49998C13.5 7.10216 13.342 6.72063 13.0607 6.43932C12.7794 6.15802 12.3978 5.99998 12 5.99998C11.6022 5.99998 11.2206 6.15802 10.9393 6.43932C10.658 6.72063 10.5 7.10216 10.5 7.49998Z",
    fill: "#36382E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9.99998H11.25C11.1125 9.99998 11 10.1 11 10.2222V17.7778C11 17.9 11.1125 18 11.25 18H12.75C12.8875 18 13 17.9 13 17.7778V10.2222C13 10.1 12.8875 9.99998 12.75 9.99998Z",
    fill: "#36382E"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info-black.f96e06e800a82d7d19df40dd4f08a0db.svg";